import MultiSlider from "./MultiSlider";
import uncontrollable from "uncontrollable";
export default uncontrollable(MultiSlider, { values: "onChange" });
